import { Component, OnInit } from '@angular/core';
import { RibbonSelectionService } from '../../ribbon/ribbon-selection.service';
import { DialogRefs } from '../../../dialog/dialog-refs';
import { nextTick } from 'q';

@Component({
    selector: 'app-completion-dialog',
    templateUrl: './completion-dialog.component.html',
    styleUrls: ['./completion-dialog.component.scss']
})
export class CompletionDialogComponent implements OnInit {
    constructor(
        public dialogRefs: DialogRefs<CompletionDialogComponent>,
        private ribbonSelectionService: RibbonSelectionService
    ) {}

    ngOnInit() {}

    cancel() {
        this.dialogRefs.close(false);
    }

    exit() {
        this.dialogRefs.close(true);
        this.ribbonSelectionService.selectTab(1);
    }
}
